exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(undefined);
// imports


// module
exports.push([module.id, ".search-cars {\n  display: -ms-flexbox;\n  display: flex;\n  -ms-flex-pack: justify;\n  justify-content: space-between;\n  background: #f1f1f2;\n  border-top: 1px solid #d8d8d8;\n  border-bottom: 1px solid #d8d8d8;\n  -ms-flex-align: center;\n  align-items: center;\n  padding-left: 16px; }\n  .search-cars > .count {\n    font-size: 14px;\n    line-height: 1.2;\n    text-transform: uppercase;\n    color: #979797; }\n  .search-cars .sorting {\n    padding: 0;\n    width: 48px;\n    height: 48px;\n    outline: none !important; }\n    .search-cars .sorting i {\n      font-size: 20px;\n      color: #979797; }\n", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?{"importLoaders":1}!./node_modules/sass-loader/lib/loader.js!./node_modules/postcss-loader/lib?{"ident":"postcss","plugins":[null,null]}!./src/components/SearchCount/styles.scss
// module id = 1339
// module chunks = 0